import backgroundImg from 'url:../img/1.jpg';
import cognitoApi from './cognitoAPI.js';
import {importHtmlFiles, Storage} from './utils.js';

function AuthenticationControl() {

    var REDIRECT_PAGE = "admin.html";
    var PAGE_NOT_FOUND_PAGE = "page-not-found.html";

    //////////////public methods

    this.initLoginPage = function (showLoginPage) {
        if (!showLoginPage) {
            location.href = PAGE_NOT_FOUND_PAGE;
            return;
        }
        cognitoApi.getApiKey(function (err, result) {
            if (!err) {
                location.href = REDIRECT_PAGE;
                return;
            }
            importHtmlFiles(function () {
                $.backstretch(backgroundImg);
                _initLoginPageSecondStep();
            });
        });
    };

    this.initForgotPasswordPage = function () {
        cognitoApi.getApiKey(function (err, result) {
            if (!err) {
                location.href = REDIRECT_PAGE;
                return;
            }
            importHtmlFiles(function () {
                $.backstretch(backgroundImg);
                _initForgotPasswordPageSecondStep();
            });
        });
    };

    this.initChangePasswordPage = function () {
        cognitoApi.getApiKey(function (err, result) {
            if (!err) {
                location.href = REDIRECT_PAGE;
                return;
            }
            importHtmlFiles(function () {
                $.backstretch(backgroundImg);
                _initChangePasswordPageSecondStep();
            });
        });
    };

    this.initConfirmForgotPasswordPage = function () {
        cognitoApi.getApiKey(function (err, result) {
            if (!err) {
                location.href = REDIRECT_PAGE;
                return;
            }
            importHtmlFiles(function () {
                $.backstretch(backgroundImg);
                _initConfirmForgotPasswordPageSecondStep();
            });
        });
    };

    this.signIn = function () {
        if (!_emptyFieldValidateForLoginFields()) {
            $("#login").button('loading');
            var username = document.getElementById('username').value;
            var password = document.getElementById('password').value;
            cognitoApi.login(username, password, _loginCallback);
        }
    };

    this.changePassword = function () {
        var username = Storage.getLocalItem("username");
        var session = Storage.getLocalItem("session");
        var newPassword = document.getElementById('new_password').value;
        var confirmPassword = document.getElementById('confirm_password').value;

        if (newPassword.length < 6) {
            var errMsg1 = "The password must have a length of at least 6.";
            document.getElementById("err_msg").innerHTML = errMsg1;
            return;
        }

        if (newPassword !== confirmPassword) {
            var errMsg2 = "Password does not match the confirm password.";
            document.getElementById("err_msg").innerHTML = errMsg2;
            return;
        }
        if (!username || !session) {
            var errMsg3 = "Internal Error";
            document.getElementById("err_msg").innerHTML = errMsg3;
            return;
        }
        _loadingSendChangePasswordFormBtn();
        cognitoApi.changeCogUserPassword(session, username, newPassword, function (err, result) {
            if (err) {
                var errMsg = "";
                if (err.code) {
                    errMsg = err.message;
                } else {
                    errMsg = "Internal Error";
                }
                document.getElementById("err_msg").innerHTML = errMsg;
                _resetSendChangePasswordFormBtn();
                return;
            }
            Storage.removeLocalItem('username');
            Storage.removeLocalItem('session');
            cognitoApi.login(username, newPassword, _loginCallback);
        });
    };

    this.sendSecretKey = function () {
        var username = document.getElementById('username').value;
        Storage.setLocalItem("username", username);
        _loadingSendForgotPasswordFormBtn();
        cognitoApi.forgotPassword(username, function (err, result) {
            _resetSendForgotPasswordFormBtn();
            if (err) {
                var errMsg = "";
                if (err.code == "UserNotFoundException" || err.code == "InvalidParameterException") {
                    errMsg = "The username you provided was not found. Did you mistype it?";
                } else if (err.code) {
                    errMsg = err.message;
                } else {
                    errMsg = "Internal Error";
                }
                document.getElementById("err_msg").innerHTML = errMsg;
                return;
            }
            if (result && result.CodeDeliveryDetails && result.CodeDeliveryDetails.Destination) {
                Storage.setLocalItem("destination", result.CodeDeliveryDetails.Destination);
            }
            location.href = "confirm-forgot-password.html";
        });
    };

    this.confirmForgotPassword = function () {
        var username = Storage.getLocalItem("username");
        var verificationCode = document.getElementById('forgot_password_code').value;
        var newPassword = document.getElementById('new_password').value;
        var checkPassword = document.getElementById('confirm_password').value;
        if (newPassword.length < 6) {
            var errMsg1 = "The password must have a length of at least 6.";
            document.getElementById("err_msg").innerHTML = errMsg1;
            return;
        }
        if (newPassword !== checkPassword) {
            var errMsg2 = "Password does not match the confirm password.";
            document.getElementById("err_msg").innerHTML = errMsg2;
            return;
        }
        _loadingSendConfirmForgotPasswordFormBtn();
        cognitoApi.confirmPassword(username, verificationCode, newPassword, function (err, result) {
            if (err) {
                var errMsg = "";
                if (err.code) {
                    errMsg = err.message;
                } else {
                    errMsg = "Internal Error";
                }
                document.getElementById("err_msg").innerHTML = errMsg;
                _resetSendConfirmForgotPasswordFormBtn();
                return;
            }
            Storage.removeLocalItem('username');
            Storage.removeLocalItem('destination');
            cognitoApi.login(username, newPassword, _loginCallback);
        });
    };

    this.logout = function () {
        cognitoApi.signOut();
        Storage.removeLocalItem('role');
        Storage.removeLocalItem('username');
        location.href = "./";
    };

    //////////////private methods

    function _initLoginPageSecondStep() {
        $('.login-form input[type="text"], .login-form input[type="password"], .login-form textarea').on('focus', function () {
            $(this).removeClass('input-error');
        });
    }

    function _initForgotPasswordPageSecondStep() {
        $('.login-form input[type="text"], .login-form input[type="password"], .login-form textarea').on('focus', function () {
            $(this).removeClass('input-error');
        });
    }

    function _initChangePasswordPageSecondStep() {
        $('.login-form input[type="text"], .login-form input[type="password"], .login-form textarea').on('focus', function () {
            $(this).removeClass('input-error');
        });
    }

    function _initConfirmForgotPasswordPageSecondStep() {
        var destination = Storage.getLocalItem("destination");
        if (destination) {
            var infoMsg = "We have sent a password reset code by email to " + destination +
             ". Enter it below to reset your password.";
            document.getElementById("info_msg").innerHTML = infoMsg;
        }
        $('.login-form input[type="text"], .login-form input[type="password"], .login-form textarea').on('focus', function () {
            $(this).removeClass('input-error');
        });
    }

    function _emptyFieldValidateForLoginFields() {
        var isEmpty = false;
        $('#sign_form').find('input[type="text"], input[type="password"]').each(function () {

            if ($(this).val() == "") {
                $(this).addClass('input-error');
                isEmpty = true;

            } else {
                $(this).removeClass('input-error');

            }
        });
        return isEmpty;
    }

    function _loadingSendConfirmForgotPasswordFormBtn() {
        var sendConfirmForgotPasswordForm = $("#sendConfirmForgotPasswordForm");
        if (sendConfirmForgotPasswordForm) {
            sendConfirmForgotPasswordForm.button('loading');
        }
    }

    function _loadingSendForgotPasswordFormBtn() {
        var sendForgotPasswordForm = $("#sendForgotPasswordForm");
        if (sendForgotPasswordForm) {
            sendForgotPasswordForm.button('loading');
        }
    }

    function _loadingSendChangePasswordFormBtn() {
        var sendChangePasswordForm = $("#sendChangePasswordForm");
        if (sendChangePasswordForm) {
            sendChangePasswordForm.button('loading');
        }
    }

    function _resetLoginBtn() {
        var loginBtn = $("#login");
        if (loginBtn) {
            loginBtn.button('reset');
        }
    }

    function _resetSendChangePasswordFormBtn() {
        var sendChangePasswordForm = $("#sendChangePasswordForm");
        if (sendChangePasswordForm) {
            sendChangePasswordForm.button('reset');
        }
    }

    function _resetSendConfirmForgotPasswordFormBtn() {
        var sendConfirmForgotPasswordForm = $("#sendConfirmForgotPasswordForm");
        if (sendConfirmForgotPasswordForm) {
            sendConfirmForgotPasswordForm.button('reset');
        }
    }

    function _resetSendForgotPasswordFormBtn() {
        var sendForgotPasswordForm = $("#sendForgotPasswordForm");
        if (sendForgotPasswordForm) {
            sendForgotPasswordForm.button('reset');
        }
    }

    function _resetButtons() {
        _resetLoginBtn();
        _resetSendChangePasswordFormBtn();
        _resetSendConfirmForgotPasswordFormBtn();
    }

    var _loginCallback = {

        onSuccess: function (user) {
            _resetButtons();
            Storage.setLocalItem("role", user.role_id);
            Storage.setLocalItem("username", user.username);
            location.href = REDIRECT_PAGE;
        },

        newPasswordRequired: function (username, session) {
            Storage.setLocalItem("username", username);
            Storage.setLocalItem("session", session);
            location.href = "change-password.html";
        },

        onFailure: function (err) {
            console.log(err);
            _resetButtons();
            if (err) {
                var errMsg = "";
                if (err.code == "UserNotFoundException" || err.code == "NotAuthorizedException") {
                    errMsg = "<center><strong>Failed!</strong> Username or Password is incorrect.</center>";
                } else if (err.code === 'CodeMismatchException') {
                    errMsg = "<center><strong>Failed!</strong> Invalid verification code provided, please enter correct code.</center>";
                } else {
                    errMsg = "Internal Error";
                }

                document.getElementById("err_msg").innerHTML = errMsg;
                return;
            }
        }
    };
}

export default new AuthenticationControl();